import type { PromptOfTheDayPrompt } from '../types';

type Regeneration = Promise<readonly PromptOfTheDayPrompt[] | null>;

// Regenerations still open, so a surface that mounts mid-request joins it instead of asking again.
const openRegenerations = new Map<string, Regeneration>();
// Keys whose regeneration failed or came back empty: not asked again on this page.
const failedCacheKeys = new Set<string>();

// Starts a regeneration, or joins the open one; `null` once one failed on this page. A success
// frees the key, so the next time the list runs out it asks again.
export const regenerateOnce: (
	cacheKey: string,
	regenerate: () => Regeneration,
) => Regeneration | null = (cacheKey, regenerate) => {
	const open = openRegenerations.get(cacheKey);
	if (open !== undefined) {
		return open;
	}
	if (failedCacheKeys.has(cacheKey)) {
		return null;
	}

	const regeneration = regenerate().then((prompts) => {
		openRegenerations.delete(cacheKey);
		if (prompts === null) {
			failedCacheKeys.add(cacheKey);
		}
		return prompts;
	});
	openRegenerations.set(cacheKey, regeneration);
	return regeneration;
};

/** Test seam: the state above otherwise leaks between cases. */
export const testing_resetPromptOfTheDayRegeneration: () => void = () => {
	openRegenerations.clear();
	failedCacheKeys.clear();
};
